export default __webpack_public_path__ + "static/media/zebraFINAL.46e54696.svg";